<div class="Bienvenido2">
</div>
<div class="container-fluid Bienvenido justify-content-center">
    <app-menu></app-menu>  
    <router-outlet></router-outlet>
</div>